import { render, staticRenderFns } from "./FiltroPeriodoBadges.vue?vue&type=template&id=9378a324&scoped=true"
import script from "./FiltroPeriodoBadges.vue?vue&type=script&lang=js"
export * from "./FiltroPeriodoBadges.vue?vue&type=script&lang=js"
import style0 from "./FiltroPeriodoBadges.vue?vue&type=style&index=0&id=9378a324&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9378a324",
  null
  
)

export default component.exports